import { DefineComponentProps } from 'utils'
import './LoadingView.scss'

type LoadingViewProps = {
  color?: string
}

export const LoadingView = defineComponent<LoadingViewProps>({
  props: DefineComponentProps<LoadingViewProps>(['color']),
  setup(props) {
    return () => (
      <div class="loading-view" style={props.color ? { '--loading-view-color': props.color } : undefined}>
        <div class="line1 loading-line" />
        <div class="line2 loading-line" />
        <div class="line3 loading-line" />
        <div class="line4 loading-line" />
      </div>
    )
  },
})
